/* AddZoneComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

const Renderer = require("./AddZoneRenderer");

/**
 * @class AddZoneComponent
 * @extends EventEmitter
 *
 * @fires AddZoneComponent#Data
 * @fires AddZoneComponent#Error
 * @fires AddZoneComponent#Shutdown
 */

class AddZoneComponent extends EventEmitter {
    constructor(data) {
        super();
        this._engineZoneEntity = data.engineZoneEntity;
        this._engineZoneEntityFeed = data.engineZoneEntityFeed;
        this._orgId = data.orgId;
        this._orgHasLicense = data.orgHasLicense;
        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    get orgHasLicense() {
        return this.getOrgHasLicense();
    }

    getOrgHasLicense() {
        return this._orgHasLicense
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _triggerData(data) {
        /**
         * @event AddZoneComponent#Data
         * @param {Object} - entity properties.
         */
        this.emit("Data", data);
    }

    _triggerError(error) {
        /**
         * @event AddZoneComponent#Error
         * @param {*} - entity properties.
         */
        this.emit("Error", error);
    }

    _triggerCreate() {
        this.emit("ZoneCreated");
    }

    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();

        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._shutdownProm = null;
                this._isMaster = null;
                this._engineZoneEntity = null;
                this._engineZoneEntityFeed = null;
                this.removeAllListeners();
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp() {
        this.rejectPopUp({ userRejected: true });
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/

    /**
     * Create a new Engine Zone entity.
     * @param data
     */
    createEngineZone(data) {
        let existingInstances = this._engineZoneEntityFeed.getInstanceWhere((instance) => {
            return instance.zoneName === data.name;
        })
        if (!_.isEmpty(existingInstances)) {
            this._triggerError({
                errorCode: "NameExists",
                errorMsg: "Zone with that name already exists."
            });
            return;
        }
        // valid names
        let validRegex = /^[a-zA-Z0-9-_]+$/;
        if (!validRegex.test(data.name) ||
        data.name.length > 50) {
            this._triggerError({
                errorCode: "Invalid Name",
                errorMsg: "Zone names must be 50 characters or less and must be alpha numeric characters with no spaces."
            });
            return;
        }
        let newEngineZone = new this._engineZoneEntity(this._orgId);

        newEngineZone.setName(String(data.name));
        newEngineZone.setZoneName(String(data.name));
        newEngineZone.setDisplayName(String(data.displayName));

        const submitPromise = newEngineZone.createStatic();

        submitPromise
            .then(() => {
                this._triggerCreate();
                return this.resolvePopup();
            })
            .catch(this._triggerError.bind(this));
    }
}

module.exports = AddZoneComponent;
